<template>
	<div class="box">
		<!-- <div class = "search-div">
			<van-search shape="round" v-model="searchKey" placeholder="请输入搜索关键词" />
		    <div class = "location-tip">城市定位</div>
			<div v-if="sCity" class = "location-div">
				<van-icon name="location" color="this.$enums.CONSTANT.APP_THEME_COLOR"/>
				<span @click="toSearchShop()">{{sCity}}</span>
			</div>
			<div v-if="!sCity" class = "location-div" @click = "getTxlocation()">
				<van-icon name="replay" color="this.$enums.CONSTANT.APP_THEME_COLOR"/>
				<span>重新获取定位</span>
			</div>
		</div> -->
		<div class="serachbox">
			<van-search shape="round" id="search" v-model="searchKey" @input="inputKeyWrod" @focus="onFocus"
				placeholder="请输入搜索关键词" @search="onSearch" show-action @cancel="onCancel" >

			</van-search>
		</div>
		<div id="amapbox" class="mapbox"></div>
		<div class="otherplane" id="plane">
			<van-list v-model="listLoading" :finished="listFinish" finished-text="当前范围没有更多了" @load="listLoad">
				<div class="shopitem" v-for="item in shopList" :key="item.id" :id="item.id" @click="itemClick(item)">
					<div class="names">{{ item.name }}</div>
					<div class="address">{{ item.cityname + item.adname + item.address }}</div>
					<div class="tips" v-if="!focusOn">
						<span>
							距离:{{ getKilometer(item.distance) }}</span>
					</div>
				</div>
			</van-list>
		</div>
		<!-- <iframe id="mapPage" width="100%" height="100%" frameborder=0
		    :src="iframeSrc">
		</iframe> -->
		<!-- <div class = "empty-div"></div>
		<div class = "city-list-div">
			<van-index-bar>
			   <div class="city-div" :class="{'city-div-bg':!searchKey}" v-for="(name_item,name_index) in this.$enum.CITY.CITYS" :key="name_index">
			     <van-index-anchor v-if="!searchKey" :index="name_item.index" />
			     <van-cell @click="selectCity(city_item.name)" v-if="!searchKey || city_item.name.indexOf(searchKey) != -1" v-for="(city_item,city_index) in name_item.citys" :title="city_item.name" :key="city_index"/>
			   </div>
			</van-index-bar>
		</div> -->
	</div>
</template>

<script>
import { mapState, mapGetters, mapMutations, mapActions } from "vuex";
import { IndexBar, Cell, IndexAnchor, Search, Icon, Notify, List } from 'vant';
import { Loader } from '../components/searchShop/AMapLoader'
export default {
	name: 'location',
	computed: {
		...mapGetters(["sLocation", "sCity"]),
		// iframeSrc() {
		//       let coord = (this.sLocation.lat && this.sLocation.lng)?this.sLocation.lng + ',' + this.sLocation.lat:'';
		//     //   return `https://apis.map.qq.com/tools/locpicker?search=1&type=1&key=XXFBZ-QI7K3-DWV3F-3UC63-WW6X6-M5FWF&referer=myapp&coord=${coord}`
		// 	return `https://m.amap.com/picker/?keywords=星巴克&zoom=15&center=${coord}&key=e80178faf00eb54f4658791c970a91f0`
		// }
	},
	components: {
		[IndexBar.name]: IndexBar,
		[IndexAnchor.name]: IndexAnchor,
		[Cell.name]: Cell,
		[Search.name]: Search,
		[Icon.name]: Icon,
		[Notify.name]: Notify,
		[List.name]: List
	},
	created() {
		//查询定位信息
		//this.getTxlocation();
		Loader("amapbox").then((AMap) => {
			this.gdmap = new AMap.Map("amapbox", {
				viewMode: '2D',
				zoom: 18,
				center: [this.sLocation.lng, this.sLocation.lat]
			})
			this.marker = new AMap.Marker({
				icon: "https://webapi.amap.com/theme/v1.3/markers/n/mark_b.png",
				position: [this.sLocation.lng, this.sLocation.lat],
				anchor: 'center'
			})
			this.gdmap.on('click', (e) => {
				console.log(e);
				if (e.lnglat) {
					this.gdmap.setZoomAndCenter(15, [e.lnglat.lng, e.lnglat.lat])
					this.marker.setPosition([e.lnglat.lng, e.lnglat.lat])
					this.amapPlace.setPageIndex(1)
					this.shopList = []
					this.addLocation(this.sCity, e.lnglat.lat, e.lnglat.lng, this.sLocation.adcode)
					this.placeSearch(e.lnglat.lng, e.lnglat.lat)
				}
			})
			this.gdmap.add(this.marker)
			AMap.plugin(["AMap.PlaceSearch", "AMap.AutoComplete"], () => {
				this.amapPlace = new AMap.PlaceSearch({
					pageSize: this.pageSize,
					pageIndex: this.pageIndex,
					// city: this.sLocation.adcode,
					// citylimit: true,
					map: this.gdmap,
					autoFitView: false
					// panel:false
					// panel:'plane'
				})
				// let autoOption = {
				// 	city:'全国',
				// 	input:"search"
				// }
				// let autoCom = new AMap.AutoComplete(autoOption)
				// autoCom.on("select",(e)=>{
				// 	// console.log(e);
				// 	// this.amapPlace.
				// 	this.shopList =[]
				// 	this.placeSearch(e.poi.location.lng,e.poi.location.lat)
				// })
				this.placeSearch(this.sLocation.lng, this.sLocation.lat)
			})
		})
	},
	beforeDestroy() {
		window.removeEventListener('message', this.messageLoc, false);
		this.gdmap.destroy()
	},
	mounted() {
		window.addEventListener('message', this.messageLoc, false);
	},
	data() {
		return {
			searchKey: '',
			gdmap: null,
			amapPlace: null,
			listLoading: false,
			listFinish: false,
			focusOn: false,
			total: 0,
			pageSize: 20,
			pageIndex: 1,
			timer:null,
			marker: {},
			shopList: []
		}
	},
	methods: {
		messageLoc(event) {
			var loc = event.data;
			// console.log(event)
			if (loc && loc.module == 'locationPicker') {//防止其他应用也会向该页面post信息，需判断module是否为'locationPicker'
				// console.log('location', loc);
				this.addLocation(loc.cityname, loc.latlng.lat, loc.latlng.lng);
				this.$router.push("searchShop")
			}
		},
		...mapMutations(['sSetLocation']),
		selectCity(city) {
			city = city + "市";
			this.addLocation(city, '', '');
			this.$router.push("searchShop")
		},
		itemClick(item) {
			console.log(item);
			this.addLocation(item.cityname, item.location.lat, item.location.lng, item.adcode)
			this.$router.push({
				name: "searchShop",
				query: {
					n: 1
				}
			})
		},
		onFocus() {
			let dom = document.getElementById("plane")
			this.focusOn = true
			if (dom) {
				dom.style = "top:60px;height:90%;z-index:180"
			} else {
				dom.style = ""
			}
		},
		blurInput() {
			let dom = document.getElementById("plane")
			if (this.focusOn) {
				if (dom) {
					dom.style = ""
					this.focusOn = false
					this.searchKey = ''
					this.shopList = []
					this.placeSearch(this.sLocation.lng, this.sLocation.lat)
				}
			}
		},
		onSearch(){
			this.shopList = []
			this.gdSearch(this.searchKey)
			let dom = document.getElementById("plane")
			if(dom){
				dom.style = ""
			}
			this.placeSearch(this.sLocation.lng, this.sLocation.lat)
		},
		onCancel(){
			this.pageIndex = 1
			this.searchKey = ""
			this.shopList = []
			let dom = document.getElementById("plane")
			if(dom){
				dom.style = ""
			}
			this.focusOn = false
			this.placeSearch(this.sLocation.lng, this.sLocation.lat,this.searchKey)
		},
		placeSearch(lng, lat, key) {
			let keyword = key ? key : "星巴克"
			this.amapPlace.searchNearBy(keyword, [lng, lat], 3000, (e, res) => {
				console.log(e, res);
				if (res.info == "OK") {
					if (this.shopList.length > 0) {
						this.shopList = this.shopList.concat(res.poiList.pois)
					} else {
						this.shopList = res.poiList.pois
					}
					this.listLoading = false
					this.total = res.poiList.count
					if (this.shopList.length >= this.total) {
						this.listFinish = true
					}
				} else {
					this.listLoading = false
					this.listFinish = true
				}
			})
		},
		listLoad() {
			console.log('loading');
			if (this.amapPlace) {
				this.amapPlace.setPageIndex(++this.pageIndex)
				if (this.searchKey != "") {
					this.gdSearch(this.searchKey)
				} else {
					this.placeSearch(this.sLocation.lng, this.sLocation.lat)
				}
			}
		},

		gdSearch(key) {
			this.amapPlace.search(key, (e, res) => {
				console.log(e, res);
				if (e == "complete") {
					if (res.info == "OK") {
						if (this.shopList.length > 0) {
							this.shopList = this.shopList.concat(res.poiList.pois)
						} else {
							this.shopList = res.poiList.pois
						}
						this.listLoading = false
						this.total = res.poiList.count
						if (this.shopList.length >= this.total) {
							this.listFinish = true
						}
					} else {
						this.listFinish = true
						this.listLoading = false
					}
				}
			})
		},

		inputKeyWrod(value) {
			if (value != '') {
				console.log(1);
				let arr = value.match(/.+?(省|市|自治区|自治州|县|区|镇|村)/g)
				this.timer = setTimeout(() => {
					if (!arr || arr.length == 0) {
						this.amapPlace.setCity(this.sCity)
						this.amapPlace.setCityLimit(true)
					} else {
						this.amapPlace.setCity("全国")
						this.amapPlace.setCityLimit(false)
					}
					// console.log(this.amapPlace)
					this.shopList = []
					this.gdSearch(value)
				}, 300)
			}
		},
		getKilometer(number) {
			return Number(number) > 1000 ? parseFloat(Number(number) / 1000).toFixed(2) + "km" : number + "m"
		},
		// getPj(biz){
		// 	return biz?biz.rating?biz.rating:0:0
		// },
		// getCost(item){
		// 	return item.cost
		// },
		addLocation(city, lat, lng, adcode) {
			this.sSetLocation({
				'city': city,
				'lat': lat,
				'lng': lng,
				'adcode': adcode
			});
		},
		toSearchShop() {
			this.$router.push("searchShop")
		}
	}

}
</script>

<style scoped>
.box {
	width: 100%;
	height: 100%;
}

.mapbox {
	width: 100%;
	height: 50%;
}

.serachbox {
	position: fixed;
	top: 0;
	width: 100%;
	z-index: 2;
}

.otherplane {
	height: 50%;
	position: absolute;
	top: 50%;
	width: 100%;
	overflow: auto;
	background-color: #fafafa;
	display: flex;
	flex-direction: column;
	row-gap: 10px;
}

.shopitem {
	/* height: 80px; */
	font-size: 14px;
	padding: 0 10px 4px 10px;
	display: flex;
	flex-direction: column;
	row-gap: 4px;
	/* box-shadow: 0 0 1px 1px rgba(0, 0, 0, 0.3); */
	border-bottom: 1px solid rgb(215, 215, 215);
	padding-top: 6px;
}

.search-div {
	position: fixed;
	top: 0px;
	left: 0px;
	padding: 15px;
	width: 100%;
	height: 128px;
	background-color: #ffffff;
	z-index: 100;
}

.names {
	font-weight: bold;
}

.address {
	color: #858585;
}

.tips {
	color: rgb(254, 140, 33);
	display: flex;
	justify-content: flex-end;
}

.search-div .van-search {
	padding: 0px;
}

.empty-div {
	width: 100%;
	height: 138px;
	background-color: #f5f5f5;
}

.location-div {
	display: inline-flex;
	align-items: center;
	padding-bottom: 5px;
}

.location-div>span {
	font-size: 17px;
	line-height: 17px;
	font-weight: 600;
	color: #363636;
	margin-left: 6px;
}

.location-div>i {
	font-size: 15px;
}

.location-tip {
	color: #858585;
	padding: 10px 0px;
	font-size: 15px;
}

.city-div-bg>div:first-child {
	background-color: #f5f5f5;
}

.city-list-div {
	height: calc(100% - 138px);
	overflow-y: auto;
}
</style>
